import { render, staticRenderFns } from "./AppSettings.vue?vue&type=template&id=2b6a6b09&"
import script from "./AppSettings.vue?vue&type=script&lang=js&"
export * from "./AppSettings.vue?vue&type=script&lang=js&"
import style0 from "./AppSettings.vue?vue&type=style&index=0&id=2b6a6b09&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports